export default "__VITE_ASSET__373c24b3__"